var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-drawer-logout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1572",
    "data-name": "Rectangle 1572",
    width: 24,
    height: 24,
    rx: 8,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "logout_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M7.677,26.128A1.72,1.72,0,0,1,6,24.451V7.677A1.72,1.72,0,0,1,7.677,6h8.135V7.677H7.677V24.451h8.135v1.677Zm13.587-5.172-1.2-1.2L22.913,16.9H13.129V15.225h9.729l-2.851-2.851,1.2-1.2,4.92,4.92Z",
    transform: "translate(-4.064 -4.064)",
    fill: "rgba(0,0,0,0.6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/Logout-icon.87075a3c87275251a3bfd0044ec95a84.svg";
export { ForwardRef as ReactComponent };